import React from 'react'
const img = require("../../assets/bannerette.jpg")

const Bannerette = (props) => (
    <img width={!props.width ? 300 : props.width} src={img} style={{ borderRadius: '50%' }} alt="Logo_evento" />
)

export default Bannerette
